import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ContentBox from 'components/CncUI/ContentBox';
import Typography from 'components/CncUI/Typography';
import Button from 'components/CncUI/Button';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    maxWidth: '100%',
    height: 'auto',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  image: {
    borderRadius: 4,
  },
  appName: {
    maxWidth: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    marginTop: 16,
    marginBottom: 0,
    marginLeft: 4,
  },
  appCaption: {
    maxWidth: '100%',
    maxHeight: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    marginTop: 0,
    marginBottom: 16,
    marginLeft: 4,
  },
}));

const IS_PROD = process.env.REACT_APP_ENVIRONMENT === 'prod';

const Item = props => {
  const classes = useStyles();
  const { uri, name, asset } = props;
  const { caption = 'Production Workflow, Reinvented' } = props;
  const newUri = IS_PROD
    ? uri.replace('castandcrew.okta', 'login.castandcrew')
    : uri.replace('castandcrew-dev.okta', 'login.dev.aws.castandcrew');

  const key = item => `AppLink-${name.replace(/ /g, '')}${item}`;

  return (
    <ContentBox dense>
      <Grid container spacing={0} justify="center">
        <Grid item xs={2} className={classes.wrapper}>
          <img
            src={asset}
            alt={name}
            className={classes.image}
            id={key('AppIcon')}
          />
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={1} justify="center" alignItems="stretch">
            <Grid item xs={12}>
              <Typography
                variant="body1"
                className={classes.appName}
                id={key('AppName')}
              >
                {name}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                italic
                variant="caption"
                className={classes.appCaption}
                id={key('Caption')}
              >
                {caption}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2} className={classes.wrapper}>
          <Button
            circle
            tertiary
            href={newUri}
            rel="noopener noreferrer"
            id={key('Button')}
          >
            <OpenInNewIcon
              className={classes.linkButton}
              id={key('ButtonIcon')}
            />
          </Button>
        </Grid>
      </Grid>
    </ContentBox>
  );
};

export default Item;
